import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const getPackageName = (state: BP42InitialState): string => state.packageName;

export default getPackageName;
